// // src/config/apiEndpoints.ts
// export const API_ENDPOINTS = {
//     // Home page endpoints
//     VACANCIES: '/vacancies',
//     PRODUCTS: '/products/public',
//     SERVICES: '/services/public',

//     // Chat endpoints
//     CHAT_ROOMS: '/chat',
//     CHAT_DIRECT: '/chat/direct',
//     CHAT_MESSAGE_REQUESTS: '/chat/message-requests',
//     CHAT_REQUEST_RESPONSE: (requestId: string) => `/chat/message-request/${requestId}`,
//     CHAT_USER_BUSINESSES: '/chat/businesses',
//     // ADD THESE MESSAGE ENDPOINTS:
//     CHAT_MESSAGES: (roomId: string) => `/messages/${roomId}`, // Note: Using /api/messages route
//     CHAT_SEND_MESSAGE: () => `/messages`, // Note the difference in route

//     // Media upload
//     CHAT_UPLOAD_MEDIA: '/chat/upload-media',
//     CHAT_INIT_CHUNKED_UPLOAD: '/chat/init-chunked-upload',
//     CHAT_UPLOAD_CHUNK: '/chat/upload-chunk',
//     CHAT_COMPLETE_CHUNKED_UPLOAD: '/chat/complete-chunked-upload',
//     CHAT_ABORT_CHUNKED_UPLOAD: '/chat/abort-chunked-upload',

//     // Group management
//     CHAT_GROUPS: '/chat/groups',
//     CHAT_POTENTIAL_MEMBERS: '/chat/groups/potential-members',
//     CHAT_GROUP_DETAILS: (roomId: string) => `/chat/groups/${roomId}/details`,
//     CHAT_GROUP_MEMBERS: (roomId: string) => `/chat/groups/${roomId}/members`,
//     CHAT_GROUP_MEDIA: (roomId: string) => `/chat/groups/${roomId}/media`,
//     CHAT_GROUP_LEAVE: (roomId: string) => `/chat/groups/${roomId}/leave`,
//     CHAT_GROUP_UPDATE: (roomId: string) => `/chat/groups/${roomId}`,
//     CHAT_GROUP_AVATAR: (roomId: string) => `/chat/groups/${roomId}/avatar`,
//     CHAT_GROUP_ADD_MEMBERS: (roomId: string) => `/chat/groups/${roomId}/members`,
//     CHAT_GROUP_UPDATE_MEMBER_ROLE: (roomId: string, memberId: string) => `/chat/groups/${roomId}/members/${memberId}`,
//     CHAT_GROUP_REMOVE_MEMBER: (roomId: string, memberId: string) => `/chat/groups/${roomId}/members/${memberId}`,
//     CHAT_GROUP_INVITE_LINK: (roomId: string) => `/chat/groups/${roomId}/invite-link`,
//     CHAT_GROUP_REVOKE_INVITE: (roomId: string) => `/chat/groups/${roomId}/invite-link`,
//     CHAT_GROUP_JOIN_INFO: (inviteCode: string) => `/chat/groups/join/${inviteCode}`,
//     CHAT_GROUP_JOIN: (inviteCode: string) => `/chat/groups/join/${inviteCode}`,

//     // Feed endpoints
//     FEED_GET: '/feed',
//     FEED_CREATE_POST: '/feed/posts',
//     FEED_TOGGLE_LIKE: (postId: string) => `/feed/posts/${postId}/like`,
//     FEED_USER_POSTS: (userId: string) => `/feed/user/${userId}`,
//     FEED_TRENDING_HASHTAGS: '/feed/trending-hashtags',
//     FEED_EXPLORE_POSTS: '/feed/explore',
//     FEED_SAVE_MEDIA: '/feed/media',
//     FEED_GET_COMMENTS: (postId: string) => `/feed/posts/${postId}/comments`,
//     FEED_ADD_COMMENT: (postId: string) => `/feed/posts/${postId}/comments`,
//     // Messages (if you have a separate messages endpoint)
//     // Note: Based on your backend, messages might be handled differently

//     // Business Endpoints
//     BUSINESSES: '/businesses',
//     BUSINESS_PRODUCTS: (businessId: string) => `/products/${businessId}`,
//     BUSINESS_PRODUCT_DETAILS: (productId: string) => `/products/by-id/${productId}`,
//     BUSINESS_CREATE_PRODUCT: (businessId: string) => `/products/${businessId}`,
//     BUSINESS_UPDATE_PRODUCT: (businessId: string, productId: string) => `/products/${businessId}/${productId}`,
//     BUSINESS_DELETE_PRODUCT: (businessId: string, productId: string) => `/products/${businessId}/${productId}`,
//     BUSINESS_SCANNERS: (businessId: string) => `/businesses/scanners/${businessId}`,
//     BUSINESS_SCANNER_DETAIL: (businessId: string, scannerId: string) => `/businesses/scanners/${businessId}/${scannerId}`,

//     BUSINESS_SERVICES: (businessId: string) => `/services/${businessId}`,
//     BUSINESS_CREATE_SERVICE: (businessId: string) => `/services/${businessId}`,
//     BUSINESS_UPDATE_SERVICE: (businessId: string, serviceId: string) => `/services/${businessId}/${serviceId}`,
//     BUSINESS_DELETE_SERVICE: (businessId: string, serviceId: string) => `/services/${businessId}/${serviceId}`,

//     // M-Pesa endpoints
//     BUSINESS_MPESA_STATUS: (businessId: string) => `/business/${businessId}/mpesa/status`,
//     BUSINESS_MPESA_SETUP: (businessId: string) => `/business/${businessId}/mpesa/setup`,
//     BUSINESS_MPESA_CONFIG: (businessId: string) => `/business/${businessId}/mpesa/config`,
//     BUSINESS_MPESA_TEST: (businessId: string) => `/business/${businessId}/mpesa/test`,
//     BUSINESS_MPESA_CREDENTIALS: (businessId: string) => `/business/${businessId}/mpesa/credentials`,
//     BUSINESS_MPESA_TRANSACTIONS: (businessId: string) => `/business/${businessId}/mpesa/transactions`,
//     BUSINESS_MPESA_CALLBACK: (businessId: string) => `/business/mpesa/callback/${businessId}`,

//     // Landlord Endpoints
//     LANDLORD_PROPERTIES: '/properties', // GET (my properties), POST (create)
//     LANDLORD_PROPERTY_DETAILS: (propertyId: string) => `/properties/${propertyId}`,
//     LANDLORD_UPDATE_PROPERTY: (propertyId: string) => `/properties/${propertyId}`,

//     LANDLORD_UNITS: (propertyId: string) => `/properties/${propertyId}/units`,
//     LANDLORD_CREATE_UNIT: (propertyId: string) => `/properties/${propertyId}/units`,
//     LANDLORD_UPDATE_UNIT: (propertyId: string, unitId: string) => `/properties/${propertyId}/units/${unitId}`,
// };
// src/config/apiEndpoints.ts
export const API_ENDPOINTS = {
    // ============== AUTH ==============
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh',

    // ============== BUSINESS ==============
    BUSINESSES: '/businesses',
    BUSINESS_CREATE: '/businesses',
    BUSINESS_DETAILS: (id: string) => `/businesses/${id}`,
    BUSINESS_UPDATE: (id: string) => `/businesses/${id}`,
    BUSINESS_PUBLIC: '/businesses/public',
    BUSINESS_PUBLIC_DETAILS: (id: string) => `/businesses/public/${id}`,

    // Business Documents
    BUSINESS_DOCUMENTS: (businessId: string) => `/businesses/${businessId}/documents`,
    BUSINESS_UPLOAD_DOCUMENT: (businessId: string) => `/businesses/${businessId}/documents`,
    BUSINESS_DELETE_DOCUMENT: (businessId: string, documentId: string) =>
        `/businesses/${businessId}/documents/${documentId}`,

    // Products - Backend expects /api/businesses/products/:businessId
    BUSINESS_PRODUCTS: (businessId: string) => `/businesses/products/${businessId}`,
    BUSINESS_CREATE_PRODUCT: (businessId: string) => `/businesses/products/${businessId}`,
    BUSINESS_PRODUCT_DETAILS: (productId: string) =>
        `/businesses/products/by-id/${productId}`, // Matches router.get('/by-id/:productId')
    BUSINESS_UPDATE_PRODUCT: (businessId: string, productId: string) =>
        `/businesses/products/${businessId}/${productId}`, // Verify this logic later if update fails
    BUSINESS_DELETE_PRODUCT: (businessId: string, productId: string) =>
        `/businesses/products/${businessId}/${productId}`,

    // Existing backend route for fetching items of a specific product
    BUSINESS_PRODUCT_ITEMS: (productId: string) => `/businesses/products/${productId}/items`,

    // Services - Backend expects /api/businesses/services/:businessId
    BUSINESS_SERVICES: (businessId: string) => `/businesses/services/${businessId}`,
    BUSINESS_CREATE_SERVICE: (businessId: string) => `/businesses/services/${businessId}`,
    BUSINESS_SERVICE_DETAILS: (serviceId: string) =>
        `/businesses/services/by-id/${serviceId}`, // Assuming similar pattern
    BUSINESS_UPDATE_SERVICE: (businessId: string, serviceId: string) =>
        `/businesses/services/${businessId}/${serviceId}`,
    BUSINESS_DELETE_SERVICE: (businessId: string, serviceId: string) =>
        `/businesses/services/${businessId}/${serviceId}`,

    // Barcodes
    BUSINESS_GENERATE_BARCODE: (businessId: string, productId: string) =>
        `/businesses/products/${businessId}/${productId}/generate-barcodes`,
    BUSINESS_DELETE_BARCODE: (businessId: string, barcodeId: string) =>
        `/businesses/${businessId}/barcodes/${barcodeId}`,

    // Staff
    BUSINESS_STAFF: (businessId: string) => `/businesses/${businessId}/staff`,
    BUSINESS_ADD_STAFF: (businessId: string) => `/businesses/${businessId}/staff`,
    BUSINESS_STAFF_PROFILE: (assignmentId: string) => `/businesses/staff/profile/${assignmentId}`,
    BUSINESS_UPDATE_STAFF: (assignmentId: string) => `/businesses/staff/${assignmentId}`,
    BUSINESS_STAFF_STATUS: (assignmentId: string) => `/businesses/staff/${assignmentId}/status`,
    BUSINESS_REMOVE_STAFF: (assignmentId: string) => `/businesses/staff/${assignmentId}`,

    // Analytics
    BUSINESS_ANALYTICS: (businessId: string) => `/businesses/${businessId}/analytics`,
    BUSINESS_SALES: (businessId: string) => `/businesses/${businessId}/sales`,
    BUSINESS_REVENUE: (businessId: string) => `/businesses/${businessId}/revenue`,

    // ============== M-PESA ==============
    BUSINESS_MPESA_STATUS: (businessId: string) => `/business/${businessId}/mpesa/status`,
    BUSINESS_MPESA_SETUP: (businessId: string) => `/business/${businessId}/mpesa/setup`,
    BUSINESS_MPESA_CONFIG: (businessId: string) => `/business/${businessId}/mpesa/config`,
    BUSINESS_MPESA_TEST: (businessId: string) => `/business/${businessId}/mpesa/test`,
    BUSINESS_MPESA_CREDENTIALS: (businessId: string) => `/business/${businessId}/mpesa/credentials`,
    BUSINESS_MPESA_TRANSACTIONS: (businessId: string) => `/business/${businessId}/mpesa/transactions`,
    BUSINESS_MPESA_CALLBACK: (businessId: string) => `/business/mpesa/callback/${businessId}`,

    // ============== CHAT ==============
    // Chat Rooms — backend: GET /api/chat (router.get('/'))
    CHAT_ROOMS: '/chat',
    CHAT_DIRECT: '/chat/direct',

    // Messages — backend: GET /api/messages/:roomId, POST /api/messages
    CHAT_MESSAGES: (roomId: string) => `/messages/${roomId}`,
    CHAT_SEND_MESSAGE: '/messages',

    // Message Requests — backend: /api/chat/message-requests, /api/chat/message-request/:id
    CHAT_MESSAGE_REQUESTS: '/chat/message-requests',
    CHAT_REQUEST_RESPONSE: (requestId: string) => `/chat/message-request/${requestId}`,

    // User Businesses for Chat
    CHAT_USER_BUSINESSES: '/chat/businesses',

    // Media Upload
    CHAT_UPLOAD_MEDIA: '/chat/upload-media',
    CHAT_INIT_CHUNKED_UPLOAD: '/chat/init-chunked-upload',
    CHAT_UPLOAD_CHUNK: '/chat/upload-chunk',
    CHAT_COMPLETE_CHUNKED_UPLOAD: '/chat/complete-chunked-upload',
    CHAT_ABORT_CHUNKED_UPLOAD: '/chat/abort-chunked-upload',

    // Group Management
    CHAT_GROUPS: '/chat/groups',
    CHAT_POTENTIAL_MEMBERS: '/chat/groups/potential-members',
    CHAT_GROUP_DETAILS: (roomId: string) => `/chat/groups/${roomId}/details`,
    CHAT_GROUP_MEMBERS: (roomId: string) => `/chat/groups/${roomId}/members`,
    CHAT_GROUP_MEDIA: (roomId: string) => `/chat/groups/${roomId}/media`,
    CHAT_GROUP_LEAVE: (roomId: string) => `/chat/groups/${roomId}/leave`,
    CHAT_GROUP_UPDATE: (roomId: string) => `/chat/groups/${roomId}`,
    CHAT_GROUP_AVATAR: (roomId: string) => `/chat/groups/${roomId}/avatar`,
    CHAT_GROUP_ADD_MEMBERS: (roomId: string) => `/chat/groups/${roomId}/members`,
    CHAT_GROUP_UPDATE_MEMBER_ROLE: (roomId: string, memberId: string) =>
        `/chat/groups/${roomId}/members/${memberId}`,
    CHAT_GROUP_REMOVE_MEMBER: (roomId: string, memberId: string) =>
        `/chat/groups/${roomId}/members/${memberId}`,

    // Group Invites
    CHAT_GROUP_INVITE_LINK: (roomId: string) => `/chat/groups/${roomId}/invite-link`,
    CHAT_GROUP_REVOKE_INVITE: (roomId: string) => `/chat/groups/${roomId}/invite-link`,
    CHAT_GROUP_JOIN_INFO: (inviteCode: string) => `/chat/groups/join/${inviteCode}`,
    CHAT_GROUP_JOIN: (inviteCode: string) => `/chat/groups/join/${inviteCode}`,

    // ============== LANDLORD ==============
    LANDLORD_PROPERTIES: '/properties',
    LANDLORD_PROPERTY_DETAILS: (propertyId: string) => `/properties/${propertyId}`,
    LANDLORD_UPDATE_PROPERTY: (propertyId: string) => `/properties/${propertyId}`,
    LANDLORD_UNITS: (propertyId: string) => `/units/property/${propertyId}`,
    LANDLORD_CREATE_UNIT: () => `/units`,
    LANDLORD_UNIT_DETAILS: (unitId: string) => `/units/${unitId}/details`,
    LANDLORD_UPDATE_UNIT: (_propertyId: string, unitId: string) => // Keep as is or fix if needed. backend is /units/utilities (PUT) or maybe specific update
        `/units/${unitId}`, // Assuming generic update exists or will be added. unitRoutes has updateUtilitiesForUnits at /utilities
    // Note: createUnit in backend is POST /api/units

    // Landlord Bookings / Viewings
    LANDLORD_BOOKINGS: (_propertyId?: string) => '/bookings',
    LANDLORD_UPDATE_BOOKING: (bookingId: string) => `/bookings/${bookingId}`,


    // Landlord Utilites - Handled via Supabase Direct
    LANDLORD_UTILITIES: (propertyId: string) => `/properties/${propertyId}/utilities`, // Keep for consistency, but will use Supabase
    LANDLORD_UPDATE_UTILITY: (utilityId: string) => `/utilities/${utilityId}`,

    // Landlord Vacancies - Handled via Supabase Direct
    LANDLORD_VACANCIES: '/vacancies/landlord', // This endpoint doesn't exist, we will use Supabase
    LANDLORD_POST_VACANCY: '/vacancies', // This exists
    LANDLORD_UPDATE_VACANCY: (vacancyId: string) => `/vacancies/${vacancyId}`,

    // Landlord Reports
    LANDLORD_REPORTS: '/reports/landlord',

    // Landlord Maintenance
    LANDLORD_MAINTENANCE: '/maintenance/landlord',
    LANDLORD_UPDATE_MAINTENANCE: (requestId: string) => `/maintenance/${requestId}/status`,

    // Landlord Staff
    LANDLORD_STAFF: (propertyId: string) => `/staff/property/${propertyId}`,
    LANDLORD_STAFF_INVITE: '/staff/invite',
    LANDLORD_STAFF_PROFILE: (assignmentId: string) => `/staff/profile/${assignmentId}`,
    LANDLORD_STAFF_UPDATE_PERMISSIONS: (assignmentId: string) => `/staff/permissions/${assignmentId}`,
    LANDLORD_STAFF_UPDATE_PAYROLL: (assignmentId: string) => `/staff/payroll-settings/${assignmentId}`,
    LANDLORD_STAFF_UPDATE: (assignmentId: string) => `/staff/${assignmentId}`,
    LANDLORD_STAFF_DELETE: (assignmentId: string) => `/staff/${assignmentId}`,
    LANDLORD_STAFF_UPDATE_STATUS: (assignmentId: string) => `/staff/${assignmentId}/status`,

    // ============== FEED ==============
    FEED_GET: '/feed',
    FEED_CREATE_POST: '/feed/posts',
    FEED_TOGGLE_LIKE: (postId: string) => `/feed/posts/${postId}/like`,
    FEED_USER_POSTS: (userId: string) => `/feed/user/${userId}`,
    FEED_TRENDING_HASHTAGS: '/feed/trending-hashtags',
    FEED_EXPLORE_POSTS: '/feed/explore',
    FEED_SAVE_MEDIA: '/feed/media',
    FEED_GET_COMMENTS: (postId: string) => `/feed/posts/${postId}/comments`,
    FEED_ADD_COMMENT: (postId: string) => `/feed/posts/${postId}/comments`,

    // ============== LANDLORD PROJECTS ==============
    LANDLORD_PROJECTS: '/projects',
    LANDLORD_PROJECT_DETAILS: (projectId: string) => `/projects/${projectId}`,
    LANDLORD_CREATE_PROJECT: '/projects',
    LANDLORD_UPDATE_PROJECT: (projectId: string) => `/projects/${projectId}`,
    LANDLORD_DELETE_PROJECT: (projectId: string) => `/projects/${projectId}`,

    // ============== HOME PAGE ==============
    VACANCIES: '/vacancies',
    PRODUCTS: '/products/public',
    SERVICES: '/services/public',
};
